export default "__VITE_ASSET__f$ogjaOy__"